import data from "./styleTags.json";
import { Style } from "gc-types";
import { CollectionDesignation } from "./interfaces";

const urlsToTagsMap: { [url: string]: string } = {};

Object.keys(data).forEach((tag: string) => {
  const urls = data[tag];
  urls.forEach((url: string) => {
    urlsToTagsMap[url] = tag;
  });
});

export default function (styleItem: Style, collectionDesignation: CollectionDesignation): string | undefined {
  if (collectionDesignation === CollectionDesignation.All) {
    if (styleItem.designations_include_subscription && !styleItem.designations_include_rental) {
      return "membership";
    }
  }
  const relativeUrl = styleItem.url.replace(/^https?:\/\/[^\/]*/, "");

  return urlsToTagsMap[relativeUrl] || undefined;
}
